import { Component, inject } from '@angular/core';
import { TypeDetectorService } from '../service/type-detector.service';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { fadeInFadeOut } from 'src/app/shared/animations';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { HeaderComponent } from './header/header.component';
import { LoaderComponent } from '../../shared/loader/loader.component';
import { FooterComponent } from './footer/footer.component';
import { CustomerType, SalesforceChatModule } from '@totalenergiescode/springbox-salesforce-chat';
import { QuestionFacade } from '../facade/question.facade';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  animations: [fadeInFadeOut],
  imports: [BreadcrumbComponent, HeaderComponent, LoaderComponent, FooterComponent, SalesforceChatModule],
})
export class LayoutComponent {
  readonly TypeDetectorService = TypeDetectorService;
  readonly translateService = inject(TranslateService);
  readonly loaderService = inject(LoaderService);
  readonly customerType = inject(QuestionFacade).isB2C() ? CustomerType.B2C : CustomerType.B2B;
  readonly showChat = environment.showChat;
}
